import React from 'react'
import PropTypes from 'prop-types'
import * as request from 'services/request'
import AssignUsersToTenantModal from './assign-users-modal'
import UsersList from './users-list'
import RolesAndPermissions from './roles-and-permissions'

class TenantUsers extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      users: [],
      showAddUserModal: false,
      selectedUserId: '',
      modified: false
    }

    this.save = this.save.bind(this)
    this.handleAddUser = this.handleAddUser.bind(this)
    this.handleRemoveUser = this.handleRemoveUser.bind(this)
    this.showAddUserModal = this.showAddUserModal.bind(this)
    this.closeAddUserModal = this.closeAddUserModal.bind(this)
    this.handleSearchUser = this.handleSearchUser.bind(this)
    this.handleSelectedUser = this.handleSelectedUser.bind(this)
    this.handleSelectedRole = this.handleSelectedRole.bind(this)
    this.handleCheckedPermission = this.handleCheckedPermission.bind(this)
  }

  componentDidMount () {
    this.getTenant()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.id !== this.props.id) {
      this.setState({ selectedUserId: '' }) // eslint-disable-line
      this.getTenant()
    }
  }

  async getTenant () {
    const { id } = this.props
    const response = await request.authorized(`/tenants/${id}`)
    const { name, users } = await response.json()

    this.setState({
      name,
      users
    })
  }

  getSearchedUsers () {
    const { search, users } = this.state

    return search
      ? users.filter(u =>
          u.screenName.toLowerCase().includes(search.toLowerCase())
        )
      : users
  }

  getSelectedUser () {
    const { selectedUserId, users } = this.state

    return users.find(u => u.id === selectedUserId)
  }

  handleAddUser (user) {
    const { users } = this.state

    if (!users.some(u => u.id === user.id)) {
      this.setState({
        users: [...users, user],
        modified: true
      })
    }

    this.closeAddUserModal()
  }

  handleRemoveUser () {
    const { users, selectedUserId } = this.state

    this.setState({
      users: users.filter(u => u.id !== selectedUserId),
      selectedUserId: '',
      modified: true
    })
  }

  showAddUserModal () {
    this.setState({
      showAddUserModal: true
    })
  }

  closeAddUserModal () {
    this.setState({
      showAddUserModal: false
    })
  }

  handleSearchUser (text) {
    this.setState({
      search: text
    })
  }

  handleSelectedUser (selectedUser) {
    this.setState({
      selectedUserId: selectedUser.id
    })
  }

  handleSelectedRole (role) {
    const { users, selectedUserId } = this.state

    const userIndex = users.findIndex(u => u.id === selectedUserId)
    const oldUser = users[userIndex]

    users[userIndex] = {
      ...oldUser,
      role
    }

    this.setState({
      users,
      modified: true
    })
  }

  handleCheckedPermission (permission, checked) {
    const { users, selectedUserId } = this.state

    const userIndex = users.findIndex(u => u.id === selectedUserId)
    const oldUser = users[userIndex]

    if (!oldUser.permissions) {
      oldUser.permissions = ''
    }

    const permissionsSet = new Set(oldUser.permissions.split(' '))

    if (checked) {
      permissionsSet.add(permission)
    } else {
      permissionsSet.delete(permission)
    }

    users[userIndex] = {
      ...oldUser,
      permissions: [...permissionsSet].join(' ').trim()
    }

    this.setState({
      users,
      modified: true
    })
  }

  async save () {
    if (!this.state.modified) {
      return
    }

    const { id } = this.props
    const { users } = this.state
    const response = await request.authorized(`/tenants/${id}/users`, {
      method: 'PUT',
      body: users
    })

    const newUsers = await response.json()

    this.setState({
      users: newUsers,
      modified: false
    })
  }

  render () {
    const {
      name,
      users,
      showAddUserModal,
      selectedUserId,
      modified
    } = this.state
    const searchedUsers = this.getSearchedUsers()

    return (
      <div>
        <div className='row'>
          <div className='col-md-12 text-right'>
            <button className='btn green' onClick={this.showAddUserModal}>
              <i className='fa fa-users' /> Assign User to Selected Tenant
            </button>

            <AssignUsersToTenantModal
              onAddUser={this.handleAddUser}
              name={name}
              show={showAddUserModal}
              onClose={this.closeAddUserModal}
            />
          </div>
        </div>

        <div
          className='portlet light'
          style={{ border: '1px solid #bbb', marginTop: 10 }}
        >
          <UsersList
            users={searchedUsers}
            count={users.length}
            onSearch={this.handleSearchUser}
            className='col-md-4'
            onSelectUser={this.handleSelectedUser}
            selectedUserId={selectedUserId}
            onRemoveUser={this.handleRemoveUser}
          />

          <div className='col-md-4 col-md-offset-1 form-group margin-top-10'>
            {selectedUserId ? (
              <RolesAndPermissions
                user={this.getSelectedUser()}
                onCheckPermission={this.handleCheckedPermission}
                onSelectRole={this.handleSelectedRole}
              />
            ) : null}
          </div>

          <div className='col-md-12 text-right'>
            <button
              className='btn green text-left'
              onClick={this.save}
              disabled={!modified}
            >
              <i className='fa fa-save' /> Save Changes
            </button>
          </div>
          <div className='clearfix' />
        </div>
      </div>
    )
  }
}

TenantUsers.propTypes = {
  id: PropTypes.string.isRequired
}

export default TenantUsers



// WEBPACK FOOTER //
// ./src/pages/admin/permissions/tenant-permissions/tenant-users.js